<template>
  <div>
    <b-container fluid>
      <!-- <page-header :title="'AI 어시스턴트'" :items="items" /> -->

      <b-row>
        <b-col lg="12">
          <b-card no-body class="card">
            <b-card-body class="card-body">
              <AIChatBot />
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AIChatBot from './AIChatBot.vue';
// import PageHeader from '@/components/page-header';

export default {
  components: {
    // PageHeader,
    AIChatBot
  },
  data() {
    return {
      // items: [
      //   {
      //     text: '대시보드',
      //     href: '/'
      //   },
      //   {
      //     text: 'AI',
      //     href: '#'
      //   },
      //   {
      //     text: 'AI 어시스턴트',
      //     active: true
      //   }
      // ]
    };
  }
};
</script>

<style scoped>
/* 컨테이너가 화면 높이를 채우도록 설정 */
.container-fluid {
  height: calc(100vh - 70px); /* 상단 네비게이션 바 높이를 고려하여 조정 */
  padding-bottom: 20px;
}

.card {
  height: 100%;
}

.card-body {
  height: 100%;
  padding: 0;
}
</style>
